export const ASSIGNEE_VALUES = {
  ME: 'Me',
  UNASSIGNED: 'Unassigned',
};
